export default __webpack_public_path__ + "static/media/img-32.f459adb1.jpg";